import { render } from "./LoadingSpiner.vue?vue&type=template&id=c132e51c"
const script = {}

import "./LoadingSpiner.vue?vue&type=style&index=0&id=c132e51c&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__